import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import { FaMobileAlt, FaEnvelope, FaFacebookF, FaTwitter, FaLinkedin, FaInstagram, FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import Footer from './pages/Footer';
import ContactSection from './pages/ContactSection';
import Aboutus from './pages/About';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Gallery from './pages/Gallery';
import Enquiry from './pages/Enquiry';
import Packages from './pages/Packages';
import Booking from './pages/Booking';
import Ourfleet from './pages/Ourfleet';
import Punetomumbaicabs from './pages/Pune to Mumbai Cabs';
import Punetomumbaiairportcab from './pages/Pune to Mumbai Airport Cab';
import ScrollToTop from './components/ScrollToTop';
import Punetomumbaiinternatinalairport from './pages/Pune to Mumbai International Airport Cabs';
import Punetomumbaionewaycab from './pages/Pune to Mumbai One Way Cab';
import Punetomumbaicarhire from './pages/Pune Mumbai Car Hire';
import Punetomumbaitaxifare from './pages/Pune to Mumbai Taxi Fare';
import Punetomumbaionlinecabbooking from './pages/Pune to Mumbai Online Cab Booking';
import Pimprchichwadtomumbai from './pages/Pimpri Chinchwad to Mumbai Cabs';
import Banertomumbai from './pages/Baner to Mumbai Cabs';
import Hinjewaditomumbaicabs from './pages/Hinjewadi to Mumbai Cabs';
import Pimplesaudagar from './pages/Pimple Saudagar to Mumbai Cab Service';
import Wakadtomumbaicab from './pages/Wakad to Mumbai Cab';
import Hadapsartomumbaicabs from './pages/Hadapsar to Mumbai Cabs';
import Kalyanitomumbaicabs from './pages/Kalyani Nagar to Mumbai Taxi';
import Karegaonparktomumbaicab from './pages/Koregaon Park to Mumbai Cab';
import Kothrudtomumbaicab from './pages/Kothrud to Mumbai Cab';
import Kharaditomumbaicabs from './pages/Kharadi to Mumbai Cab';
import Svhivaninagartomumbai from './pages/Shivajinagar to Mumbai Cab';
import Punetomumbaiertigacabs from './pages/Pune to Mumbai Ertiga Cabs';
import Punetomumbaiinnovacrysta from './pages/Pune to Mumbai Innova Crysta Cab';
import Punetomumbaisedancabs from './pages/Pune to Mumbai Sedan Cab';
import Kondhwatomumbaicab from './pages/Kondhwa to Mumbai Cab';
import Vimannagartomumbaicabs from './pages/Viman Nagar to Mumbai Cabs';
import Katrajtomumbaicab from './pages/Katraj to Mumbai Cab Service';
import Punestationtomumbaicabs from './pages/Pune Station to Mumbai Cabs Service';
import Boatclubroadtomumbai from './pages/Boat Club Road to Mumbai Cab';
import Vishrantwaditomumbaicab from './pages/Vishrantwadi to Mumbai Cab';
import Alanditomumbaicabs from './pages/Alandi to Mumbai Cabs Service';
import Wagholitomumbaicab from './pages/Wagholi to Mumbai Cab';
import Mumbaitopunecabs from './pages/Mumbai to Pune Cabs';
import Mumbaiairporttopunecabs from './pages/Mumbai Airport to Pune Cab';
import Dadartopunecab from './pages/Dadar to Pune Cab';
import Mumbaitopuneonewaycab from './pages/Mumbai to Pune One Way Cab';
import Andheritopunecab from './pages/Andheri to Pune Cab';
import Bandratopunecab from './pages/Bandra to Pune Cab';
import Santacruztopunecab from './pages/Santacruz to Pune Cab';
import Mumbaicentraltopunecab from './pages/Mumbai Central to Pune Cab';
import Borivalitopunecab from './pages/Borivali to Pune Cab';
import Mumbaitopimprichichwad from './pages/Mumbai to Pimpri Chinchwad Cab';
import Navimumbaitopunecab from './pages/Navi Mumbai to Pune Cab';
import Mumbaiairporttopunecity from './pages/Mumbai Airport to Pune City Cab';
import Mumbaitopunedailycab from './pages/Mumbai to Pune Daily Cab';
import Mumbaitopuneonlinecab from './pages/Mumbai to Pune Online Cab';
import Mumbaipunecabbooking from './pages/Mumbai Pune Cab Booking';
import Jogeshwaritopunecab from './pages/Jogeshwari to Pune Cab Service';
import Garegaontopunecab from './pages/Goregaon to Pune Cab';
import Kandivalitopunecab from './pages/Kandivali to Pune Cab';
import Vileparletopunecabservice from './pages/Vile Parle to Pune Cab Service';
import Bhanduptopunecab from './pages/Bhandup to Pune Cab';
import Ghatkopartopunecab from './pages/Ghatkopar to Pune Cab Service';
import Kurlatopunetaxiservice from './pages/Kurla to Pune Taxi Service';
import Powaimumbaipunecabservice from './pages/Powai Mumbai Pune Cab Service';
import Chemburtopunecab from './pages/Chembur to Pune Cab';
import Terminalmumbai from './pages/Terminal 1,2,3 Mumbai Airport to Pune Cab';
import Thanetopunecab from './pages/Thane to Pune Cab';
import Vikhrolitopunecabservice from './pages/Vikhroli to Pune Cab Services';
import Mumbaitopuneinovacrystacab from './pages/Mumbai to Pune Innova Crysta Cab';
import Mumbaiairporttopuneertigacab from './pages/Mumbai Airport to Pune Ertiga on Rent';
import Mumbaiairportcarrental from './pages/Mumbai Airport Car Rental';
import Panveltopunecab from './pages/Panvel to Pune Cab';
import Churchgatetopune from './pages/Church Gate to Pune Cab Service';
import Bycullatopunecabservice from './pages/Byculla to Pune Cab Service';
import Vashitopunecab from './pages/Vashi to Pune Cab';
import Kharghartopunecab from './pages/Kharghar to Pune Cab';
import Mankhurdtopunecab from './pages/Mankhurd to Pune Cab';
import Punemumbaidailycabservice from './pages/Pune Mumbai Daily Cab Service';
import Onewaytaximumbaitopune from './pages/One Way Taxi Mumbai to Pune';
import Innovacrystaonrentinpune from './pages/Innova Crysta on Rent in Pune';
import Ertigacabbookinginpune from './pages/Ertiga Cab Booking in Pune';
import Kiacarenceonrent from './pages/Kia Carens On Rent in Pune';
import Swiftdezireonrentinpune from './pages/Swift Dzire On Rent in Pune';
import Sedancabsbookinginpune from './pages/Sedan Cabs Booking in Pune';
import Forceurbaniaonrentinpune from './pages/Force Urbania On Rent in Pune';
import Fortuneronrentinpune from './pages/Fortuner On Rent in Pune';
import Mumbaidarshancabs from './pages/Mumbai Darshan Cabs';
import Mumbaioutstationcabs from './pages/Mumbai Outstation Cabs';
import Mumbaitojyotilinga from './pages/Mumbai to 5 Jyotirlinga Cab';
import Mumbaitomahabaleshwar from './pages/Mumbai to Mahabaleshwar Cab';
import Mumbaitoashtavinayakdarshancabs from './pages/Mumbai to Ashtavinayak Darshan Cabs';
import Mumbaitobhimashankarcabs from './pages/Mumbai to Bhimashankar Cab';
import Mumbaitogoacabs from './pages/Mumbai to Goa Cabs';
import Mumbaitokolhapurcab from './pages/Mumbai to Kolhapur Cab';
import Mumbaitokkonkancab from './pages/Mumbai to Konkan Darshan Cab Booking';
import Mumbaitopanchganicab from './pages/Mumbai to Panchgani Cab';
import Mumbaitoshirdicab from './pages/Mumbai to Shirdi Cab';
import Forceurbaniaonrentinnavi from './pages/Force Urbania On Rent in Navi Mumbai';
import Minibusonrentinmumbai from './pages/Mini Bus On Rent in Mumbai';
import Innovacrystsonrentinmumbai from './pages/Innova Crysta On Rent in Mumbai';
import Ertigaonrentinmumbai from './pages/Ertiga On Rent in Mumbai';
import Mumbaiairportcabservice from './pages/Mumbai Airport Cab Service';
import Kiacarenceonrentmumbai from './pages/Kia Carens On Rent in Mumbai';
import Seatercaronrentinmumbai from './pages/7 Seater Car On Rent in Mumbai';
import Mumbaicabsonlinebooking from './pages/Mumbai Cabs Online Booking';
import Thanetogoacab from './pages/Thane to goa Cabs';
import Navimumbaitogoacab from './pages/Navi mumbai to goa cab service';
import Mumbaiairporttonashikairport from './pages/Mumbai airport to nashik cab';
import Mumbaiairporttosataracab from './pages/Mumbai airport to satara cab';
import Mumbaiairporttomahabaleshwar from './pages/Mumbai airport to mahabaleshwar cab service';
import Mumbaitoaurangabadcabservice from './pages/Mumbai to Aurangabad Cab Service';
import Mumbaitonagpurvia from './pages/mumbai to nagpur via samruddhi mahamarg cab service';
import Mumbaitopandharpurcab from './pages/Mumbai to pandharpur cab';
import Mumbaitoajantaellora from './pages/Mumbai to ajanta ellora tour package';
import Mumbaitoprayagrajcab from './pages/Mumbai to prayagraj cab booking';
import Mumbaitoayodhyacab from './pages/Mumbai to Ayodhya Cab Package';
import Mumbaitosolapur from './pages/Mumbai to Solapur Cab Booking';
import Cheapestcabservice from './pages/Cheapest cab service in Mumbai';
import Cheapestcabservicemumbai from './pages/Cheapest cab service in navi mumbai';
import Affordablecabserviceinmumbai from './pages/Affordable cab service in Mumbai';
import ContactButtons from './components/ContactButtons';
import CaptchaScreen from './components/CaptchaScreen';
import React, { useEffect, useState } from "react";
import Navimumbaiairportcab from './pages/Navi Mumbai Airport Cab';
import Navimumbaiairportcabservice from './pages/Navi Mumbai Airport Cab Service';
import Navimumbaiairporttopunecab from './pages/Navi Mumbai Airport to Pune Cab';
import Navimumbaiairporttonashikcab from './pages/Navi Mumbai Airport to Nashik Cab';
import Onlinecabbookingnavimumbai from './pages/Online Cab Booking Navi Mumbai Airport';
import Navimumbaiairporttolonavalacabs from './pages/Navi Mumbai Airport to Lonavala Cabs';
import Cabserviceinnavimumbai from './pages/Cab Service in Navi Mumbai';
import Navimumbaitaxiservice from './pages/Navi Mumbai Taxi Service';
import Navimumbaitomahabaleshwarcab from './pages/Navi Mumbai to Mahabaleshwar Cab';
import Navimumbaitoshirditaxifare from './pages/Navi Mumbai to Shirdi Taxi Fare';
import Kharghartaxiservice from './pages/Kharghar Taxi Service';
import Navimumbaitokolhapurcab from './pages/Navi Mumbai to Kolhapur Cab';
import Innovacrystaonrentinnavimumbai from './pages/Innova Crysta On Rent in Navi Mumbai';
import Ertigaonrentinnavimumbai from './pages/Ertiga On Rent in Navi Mumbai';
import Swiftdzireonrentinnavimumbai from './pages/Swift Dzire on Rent in Navi Mumbai';
import Navimumbaiairporttogoacab from './pages/Navi Mumbai Airport to Goa Cabs';
import Navimumbaiinternatinalairportcab from './pages/Navi Mumbai International Airport cab';
import Navimumbaitoashtavinayakcab from './pages/Navi Mumbai to Ashtavinayak Cab Service';
import Navimumbaitofivejyotilinga from './pages/Navi Mumbai to 5 Jyotirlinga Darshan Cab';
import Roundtripcabnavimumbai from './pages/Round Trip Cab Navi Mumbai';
import Outstaioncabservicenavimumbai from './pages/Outstation Cab Service Navi Mumbai';
import Punetoairporttonavimumbaicab from './pages/Pune Airport to Navi Mumbai Cab';
import Pimprichichwadtonavimumbaiairport from './pages/Pimpri Chinchwad to Navi Mumbai Airport Cab';
import Hinjewaditonavimumbaiinternatinalairportcab from './pages/Hinjewadi to Navi Mumbai International Airport Cab';
import Hadapsartonavimumbaiairportcab from './pages/Hadapsar to Navi Mumbai Airport Cab';
import Punestationtonavimumbaiairport from './pages/Pune Station to Navi Mumbai Airport Cab';
import Punetonavimumbaicab from './pages/Pune to Navi Mumbai Cab';
import Punetonavimumbaiairportonewaycab from './pages/Pune to Navi Mumbai Airport One Way Cab';
import Punetomumbaiairportcabbooking from './pages/Pune to Mumbai Airport Cab Booking';
import Kothrudtonavimumbaiairportcabservice from './pages/Kothrud to Navi Mumbai Airport Cab Service';
import Punetomumbaicabbookingonline from './pages/Pune to Mumbai Cab Booking Online';
import Punetomumbaicabservice from './pages/Pune to Mumbai Cab Service';
import Bestcabservicepunetomumbai from './pages/Best cab services Pune to Mumbai';
import Punetomumbaiintercitycab from './pages/Pune to Mumbai intercity Cab';







function App() {

  // const [showCaptcha, setShowCaptcha] = useState(false);
  // const [verified, setVerified] = useState(false);

  // useEffect(() => {
  //   const current = parseInt(localStorage.getItem("visitCount") || "0");
  //   const updated = current + 1;
  //   localStorage.setItem("visitCount", updated);

  //   if (updated >= 10) {
  //     setShowCaptcha(true);
  //     localStorage.setItem("visitCount", "0");
  //   }
  // }, []);

  // if (showCaptcha && !verified) {
  // return <CaptchaScreen onVerified={() => setVerified(true)} />;
  // }

  return (
    <Router>
   <ScrollToTop/>
    <ContactButtons/>
  <Header/>

  
      <Routes>
        
        <Route path="/" element={<HeroSection/>} />
        <Route path="/about" element={<Aboutus/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/term-condition" element={<TermsConditions/>} />
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/our-fleet" element={<Ourfleet/>} />
        <Route path="/contact-us" element={<ContactSection/>} />
        <Route path="/enquiry" element={<Enquiry/>} />
        <Route path="/packages" element={<Packages/>} />
        <Route path="/booking" element={<Booking/>} />
   

        <Route path="/Pune-to-Mumbai-Cab" element={<Punetomumbaicabs />} />
        <Route path="/Pune-to-Mumbai-Airport-Cab" element={<Punetomumbaiairportcab />} />
        <Route path="/Pune-to-Mumbai-International-Airport-Cab" element={<Punetomumbaiinternatinalairport />} />
        <Route path="/Pune-to-Mumbai-One-Way-Cab" element={<Punetomumbaionewaycab />} />
        <Route path="/Pune-Mumbai-Car-Hire" element={<Punetomumbaicarhire />} />
        <Route path="/Pune-to-Mumbai-Taxi-Fare" element={<Punetomumbaitaxifare />} />
        <Route path="/Pune-to-Mumbai-Online-Cab-Booking" element={<Punetomumbaionlinecabbooking />} />
        <Route path="/Pimpri-Chinchwad-to-Mumbai-Cab" element={<Pimprchichwadtomumbai />} />
        <Route path="/Baner-to-Mumbai-Cabs" element={<Banertomumbai />} />
        <Route path="/Hinjewadi-to-Mumbai-Cab" element={<Hinjewaditomumbaicabs />} />
        <Route path="/Pimple-Saudagar-to-Mumbai-Cab-Service" element={<Pimplesaudagar />} />
        <Route path="/Wakad-to-Mumbai-Cab" element={<Wakadtomumbaicab />} />
        <Route path="/Hadapsar-to-Mumbai-Cab" element={<Hadapsartomumbaicabs />} />
        <Route path="/Kalyani-Nagar-to-Mumbai-Taxi" element={<Kalyanitomumbaicabs />} />
        <Route path="/Koregaon-Park-to-Mumbai-Cab" element={<Karegaonparktomumbaicab />} />
        <Route path="/Kothrud-to-Mumbai-Cab" element={<Kothrudtomumbaicab />} />
        <Route path="/Kharadi-to-Mumbai-Cab" element={<Kharaditomumbaicabs />} />
        <Route path="/Shivajinagar-to-Mumbai-Cab" element={<Svhivaninagartomumbai />} />
        <Route path="/Pune-to-Mumbai-Ertiga-Cab" element={<Punetomumbaiertigacabs />} />
        <Route path="/Pune-to-Mumbai-Innova-Crysta-Cab" element={<Punetomumbaiinnovacrysta />} />
        <Route path="/Pune-to-Mumbai-Sedan-Cab" element={<Punetomumbaisedancabs />} />
        <Route path="/Kondhwa-to-Mumbai-Cab" element={<Kondhwatomumbaicab />} />
        <Route path="/Viman-Nagar-to-Mumbai-Cabs" element={<Vimannagartomumbaicabs />} />
        
        <Route path="/Katraj-to-Mumbai-Cab-Service" element={<Katrajtomumbaicab />} />
        <Route path="/Pune-Station-to-Mumbai-Cabs-Service" element={<Punestationtomumbaicabs />} />
        <Route path="/Boat-Club-Road-to-Mumbai-Cab" element={<Boatclubroadtomumbai />} />
        <Route path="/Vishrantwadi-to-Mumbai-Cab" element={<Vishrantwaditomumbaicab />} />
        <Route path="/Alandi-to-Mumbai-Cabs-Service" element={<Alanditomumbaicabs />} />
        <Route path="/Wagholi-to-Mumbai-Cab" element={<Wagholitomumbaicab />} />
        <Route path="/Mumbai-to-Pune-Cabs" element={<Mumbaitopunecabs />} />
        <Route path="/Mumbai-Airport-to-Pune-Cab" element={<Mumbaiairporttopunecabs />} />
        <Route path="/Dadar-to-Pune-Cab" element={<Dadartopunecab />} />
        <Route path="/Mumbai-to-Pune-One-Way-Cab" element={<Mumbaitopuneonewaycab />} />
        <Route path="/Andheri-to-Pune-Cab" element={<Andheritopunecab />} />
        <Route path="/Bandra-to-Pune-Cab" element={<Bandratopunecab />} />
        <Route path="/Santacruz-to-Pune-Cab" element={<Santacruztopunecab />} />
        <Route path="/Mumbai-Central-to-Pune-Cab" element={<Mumbaicentraltopunecab />} />
        <Route path="/Borivali-to-Pune-Cab" element={<Borivalitopunecab />} />
        <Route path="/Mumbai-to-Pimpri-Chinchwad-Cab" element={<Mumbaitopimprichichwad />} />
        <Route path="/Navi-Mumbai-to-Pune-Cab" element={<Navimumbaitopunecab />} />
        <Route path="/Mumbai-Airport-to-Pune-City-Cab" element={<Mumbaiairporttopunecity />} />
        <Route path="/Mumbai-to-Pune-Daily-Cab" element={<Mumbaitopunedailycab />} />
        <Route path="/Mumbai-to-Pune-Online-Cab" element={<Mumbaitopuneonlinecab />} />
        <Route path="/Mumbai-Pune-Cab-Booking" element={<Mumbaipunecabbooking />} />
        <Route path="/Jogeshwari-to-Pune-Cab-Service" element={<Jogeshwaritopunecab />} />
        <Route path="/Goregaon-to-Pune-Cab" element={<Garegaontopunecab />} />
        <Route path="/Kandivali-to-Pune-Cab" element={<Kandivalitopunecab />} />
        <Route path="/Vile-Parle-to-Pune-Cab-Service" element={<Vileparletopunecabservice />} />
        <Route path="/Bhandup-to-Pune-Cab" element={<Bhanduptopunecab />} />


        <Route path="/Ghatkopar-to-Pune-Cab-Service" element={<Ghatkopartopunecab />} />
        <Route path="/Kurla-to-Pune-Taxi-Service" element={<Kurlatopunetaxiservice />} />
        <Route path="/Powai-Mumbai-Pune-Cab-Service" element={<Powaimumbaipunecabservice />} />
        <Route path="/Chembur-to-Pune-Cab" element={<Chemburtopunecab />} />
        <Route path="/Terminal-1-2-3-Mumbai-Airport-to-Pune-Cab" element={<Terminalmumbai />} />
        <Route path="/Thane-to-Pune-Cab" element={<Thanetopunecab />} />
        <Route path="/Vikhroli-to-Pune-Cab-Services" element={<Vikhrolitopunecabservice />} />
        <Route path="/Mumbai-to-Pune-Innova-Crysta-Cab" element={<Mumbaitopuneinovacrystacab />} />
        <Route path="/Mumbai-Airport-to-Pune-Ertiga-on-Rent" element={<Mumbaiairporttopuneertigacab />} />
        <Route path="/Mumbai-Airport-Car-Rental" element={<Mumbaiairportcarrental />} />
        <Route path="/Panvel-to-Pune-Cab" element={<Panveltopunecab />} />
        <Route path="/Church-Gate-to-Pune-Cab-Service" element={<Churchgatetopune />} />
        <Route path="/Byculla-to-Pune-Cab-Service" element={<Bycullatopunecabservice />} />
        <Route path="/Vashi-to-Pune-Cab" element={<Vashitopunecab />} />
        <Route path="/Kharghar-to-Pune-Cab" element={<Kharghartopunecab />} />
        <Route path="/Mankhurd-to-Pune-Cab" element={<Mankhurdtopunecab />} />
        <Route path="/Pune-Mumbai-Daily-Cab-Service" element={<Punemumbaidailycabservice />} />
        <Route path="/One-Way-Taxi-Mumbai-to-Pune" element={<Onewaytaximumbaitopune />} />
        <Route path="/Innova-Crysta-on-Rent-in-Pune" element={<Innovacrystaonrentinpune />} />
        <Route path="/Ertiga-Cab-Booking-in-Pune" element={<Ertigacabbookinginpune />} />
        <Route path="/Kia-Carens-On-Rent-in-Pune" element={<Kiacarenceonrent />} />
        <Route path="/Swift-Dzire-On-Rent-in-Pune" element={<Swiftdezireonrentinpune />} />
        <Route path="/Sedan-Cabs-Booking-in-Pune" element={<Sedancabsbookinginpune />} />
        <Route path="/Force-Urbania-On-Rent-in-Pune" element={<Forceurbaniaonrentinpune />} />
        <Route path="/Fortuner-On-Rent-in-Pune" element={<Fortuneronrentinpune />} />


<Route path="/Mumbai-Darshan-Cabs" element={<Mumbaidarshancabs />} />
<Route path="/Mumbai-Outstation-Cabs" element={<Mumbaioutstationcabs />} />
<Route path="/Mumbai-to-5-Jyotirlinga-Cab" element={<Mumbaitojyotilinga />} />
<Route path="/Mumbai-to-Mahabaleshwar-Cab" element={<Mumbaitomahabaleshwar />} />
<Route path="/Mumbai-to-Ashtavinayak-Darshan-Cabs" element={<Mumbaitoashtavinayakdarshancabs />} />
<Route path="/Mumbai-to-Bhimashankar-Cab" element={<Mumbaitobhimashankarcabs />} />
<Route path="/Mumbai-to-Goa-Cabs" element={<Mumbaitogoacabs />} />
<Route path="/Mumbai-to-Kolhapur-Cab" element={<Mumbaitokolhapurcab />} />
<Route path="/Mumbai-to-Konkan-Darshan-Cab-Booking" element={<Mumbaitokkonkancab />} />
<Route path="/Mumbai-to-Panchgani-Cab" element={<Mumbaitopanchganicab />} />
<Route path="/Mumbai-to-Shirdi-Cab" element={<Mumbaitoshirdicab />} />
<Route path="/Force-Urbania-On-Rent-in-Navi-Mumbai" element={<Forceurbaniaonrentinnavi />} />
<Route path="/Mini-Bus-On-Rent-in-Mumbai" element={<Minibusonrentinmumbai />} />
<Route path="/Innova-Crysta-On-Rent-in-Mumbai" element={<Innovacrystsonrentinmumbai />} />
<Route path="/Ertiga-On-Rent-in-Mumbai" element={<Ertigaonrentinmumbai />} />
<Route path="/Mumbai-Airport-Cab-Service" element={<Mumbaiairportcabservice />} />
<Route path="/Kia-Carens-On-Rent-in-Mumbai" element={<Kiacarenceonrentmumbai />} />
<Route path="/7-Seater-Car-On-Rent-in-Mumbai" element={<Seatercaronrentinmumbai />} />
<Route path="/Mumbai-Cabs-Online-Booking" element={<Mumbaicabsonlinebooking />} />
<Route path="/Thane-to-Goa-Cabs" element={<Thanetogoacab />} />
<Route path="/Navi-Mumbai-to-Goa-Cab-Service" element={<Navimumbaitogoacab />} />
<Route path="/Mumbai-Airport-to-Nashik-Cab" element={<Mumbaiairporttonashikairport />} />
<Route path="/Mumbai-Airport-to-Satara-Cab" element={<Mumbaiairporttosataracab />} />
<Route path="/Mumbai-Airport-to-Mahabaleshwar-Cab-Service" element={<Mumbaiairporttomahabaleshwar />} />
<Route path="/Mumbai-to-Aurangabad-Cab-Service" element={<Mumbaitoaurangabadcabservice />} />
<Route path="/Mumbai-to-Nagpur-via-Samruddhi-Mahamarg-Cab-Service" element={<Mumbaitonagpurvia />} />
<Route path="/Mumbai-to-Pandharpur-Cab" element={<Mumbaitopandharpurcab />} />
<Route path="/Mumbai-to-Ajanta-Ellora-Tour-Package" element={<Mumbaitoajantaellora />} />
<Route path="/Mumbai-to-Prayagraj-Cab-Booking" element={<Mumbaitoprayagrajcab />} />
<Route path="/Mumbai-to-Ayodhya-Cab-Package" element={<Mumbaitoayodhyacab />} />
<Route path="/Mumbai-to-Solapur-Cab-Booking" element={<Mumbaitosolapur />} />
<Route path="/Cheapest-Cab-Service-in-Mumbai" element={<Cheapestcabservice />} />
<Route path="/Cheapest-Cab-Service-in-Navi-Mumbai" element={<Cheapestcabservicemumbai />} />
<Route path="/Affordable-Cab-Service-in-Mumbai" element={<Affordablecabserviceinmumbai />} />



<Route path="/Navi-Mumbai-Airport-Cab" element={<Navimumbaiairportcab />} />
<Route path="/Navi-Mumbai-Airport-Cab-Service" element={<Navimumbaiairportcabservice />} />
<Route path="/Navi-Mumbai-Airport-to-Pune-Cab" element={<Navimumbaiairporttopunecab />} />
<Route path="/Navi-Mumbai-Airport-to-Nashik-Cab" element={<Navimumbaiairporttonashikcab />} />
<Route path="/Online-Cab-Booking-Navi-Mumbai-Airport" element={<Onlinecabbookingnavimumbai />} />
<Route path="/Navi-Mumbai-Airport-to-Lonavala-Cabs" element={<Navimumbaiairporttolonavalacabs />} />
<Route path="/Cab-Service-in-Navi-Mumbai" element={<Cabserviceinnavimumbai />} />
<Route path="/Navi-Mumbai-Taxi-Service" element={<Navimumbaitaxiservice />} />
<Route path="/Navi-Mumbai-to-Mahabaleshwar-Cab" element={<Navimumbaitomahabaleshwarcab />} />
<Route path="/Navi-Mumbai-to-Shirdi-Taxi-Fare" element={<Navimumbaitoshirditaxifare />} />
<Route path="/Kharghar-Taxi-Service" element={<Kharghartaxiservice />} />
<Route path="/Navi-Mumbai-to-Kolhapur-Cab" element={<Navimumbaitokolhapurcab />} />
<Route path="/Innova-Crysta-On-Rent-in-Navi-Mumbai" element={<Innovacrystaonrentinnavimumbai />} />
<Route path="/Ertiga-On-Rent-in-Navi-Mumbai" element={<Ertigaonrentinnavimumbai />} />
<Route path="/Swift-Dzire-on-Rent-in-Navi-Mumbai" element={<Swiftdzireonrentinnavimumbai />} />
<Route path="/Navi-Mumbai-Airport-to-Goa-Cabs" element={<Navimumbaiairporttogoacab />} />
<Route path="/Navi-Mumbai-International-Airport-Cab" element={<Navimumbaiinternatinalairportcab />} />
<Route path="/Navi-Mumbai-to-Ashtavinayak-Cab-Service" element={<Navimumbaitoashtavinayakcab />} />
<Route path="/Navi-Mumbai-to-5-Jyotirlinga-Darshan-Cab" element={<Navimumbaitofivejyotilinga />} />
<Route path="/Round-Trip-Cab-Navi-Mumbai" element={<Roundtripcabnavimumbai />} />
<Route path="/Outstation-Cab-Service-Navi-Mumbai" element={<Outstaioncabservicenavimumbai />} />
<Route path="/Pune-Airport-to-Navi-Mumbai-Cab" element={<Punetoairporttonavimumbaicab />} />
<Route path="/Pimpri-Chinchwad-to-Navi-Mumbai-Airport-Cab" element={<Pimprichichwadtonavimumbaiairport />} />
<Route path="/Hinjewadi-to-Navi-Mumbai-International-Airport-Cab" element={<Hinjewaditonavimumbaiinternatinalairportcab />} />
<Route path="/Hadapsar-to-Navi-Mumbai-Airport-Cab" element={<Hadapsartonavimumbaiairportcab />} />
<Route path="/Pune-Station-to-Navi-Mumbai-Airport-Cab" element={<Punestationtonavimumbaiairport />} />
<Route path="/Pune-to-Navi-Mumbai-Cab" element={<Punetonavimumbaicab />} />
<Route path="/Pune-to-Navi-Mumbai-Airport-One-Way-Cab" element={<Punetonavimumbaiairportonewaycab />} />
<Route path="/Pune-to-Mumbai-Airport-Cab-Booking" element={<Punetomumbaiairportcabbooking />} />
<Route path="/Kothrud-to-Navi-Mumbai-Airport-Cab-Service" element={<Kothrudtonavimumbaiairportcabservice />} />
<Route path="/Pune-to-Mumbai-Cab-Booking-Online" element={<Punetomumbaicabbookingonline />} />
<Route path="/Pune-to-Mumbai-Cab-Service" element={<Punetomumbaicabservice />} />
<Route path="/Best-Cab-Services-Pune-to-Mumbai" element={<Bestcabservicepunetomumbai />} />
<Route path="/Pune-to-Mumbai-Intercity-Cab" element={<Punetomumbaiintercitycab />} />
        </Routes>
    
<Footer/>
    </Router>
 

  );
}

export default App;
